/* === PRIMARY: CSS Anchor Positioning — tooltip always ABOVE trigger === */
@supports (anchor-name: --x) {
  .tooltip-wrapper .tooltip-text {
    position: fixed;
    bottom: anchor(top);
    left: anchor(center);
    translate: -50% -6px;
    background: rgba(0, 0, 0, 0.8);
    color: #fff;
    border-radius: 6px;
    padding: 4px 8px;
    font-size: 0.8rem;
    white-space: pre-wrap;
    max-width: 300px;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.15s ease, visibility 0.15s ease;
    z-index: 9999;
    pointer-events: none;
  }

  .tooltip-wrapper .tooltip-text::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 5px solid transparent;
    border-top-color: rgba(0, 0, 0, 0.8);
  }

  .tooltip-wrapper:hover .tooltip-text {
    opacity: 1;
    visibility: visible;
  }
}

/* === FALLBACK: old absolute (browsers without anchor) — tooltip always ABOVE trigger === */
@supports not (anchor-name: --x) {
  .tooltip-wrapper .tooltip-text {
    position: absolute;
    bottom: calc(100% + 6px);
    left: 50%;
    transform: translateX(-50%);
    background: rgba(0, 0, 0, 0.8);
    color: #fff;
    border-radius: 6px;
    padding: 4px 8px;
    font-size: 0.8rem;
    white-space: pre-wrap;
    max-width: 300px;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.15s ease, visibility 0.15s ease;
    z-index: 10;
    pointer-events: none;
  }

  .tooltip-wrapper .tooltip-text::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 5px solid transparent;
    border-top-color: rgba(0, 0, 0, 0.8);
  }

  .tooltip-wrapper:hover .tooltip-text {
    opacity: 1;
    visibility: visible;
  }
}
